import { FC } from 'react'
import styled, { css } from 'styled-components'

const ExamTabTooltipDesktop: FC = () => {
  return (
    <StyledWrapper role="tooltip">
      <p className="tooltip-text">가장 빠른 답안 공개!</p>
    </StyledWrapper>
  )
}

export default ExamTabTooltipDesktop

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 148px;
    height: 41px;
    background-color: #f4fbff;
    border: 2px solid ${theme.color.primary_2} !important;
    border-radius: 18px;
    box-shadow: 0 2px 4px rgba(2, 2, 2, 0.1);

    &::after {
      content: '';
      position: absolute;
      top: -6px;
      left: 50%;
      transform: translateX(-50%) rotate(45deg);
      width: 10px;
      height: 10px;
      background-color: #f4fbff;
      border-top: 2px solid ${theme.color.primary_2} !important;
      border-left: 2px solid ${theme.color.primary_2} !important;
      z-index: -1;
    }

    > .tooltip-text {
      font-size: 15px;
      font-weight: bold;
      white-space: nowrap;
      color: ${theme.color.primary_2};
      line-height: 1.87;
      letter-spacing: -0.6px;
    }
  `}
`
